import { render, staticRenderFns } from "./DxBareRootsInfoForm.vue?vue&type=template&id=34cf1c57&scoped=true&"
import script from "./DxBareRootsInfoForm.vue?vue&type=script&lang=js&"
export * from "./DxBareRootsInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./DxBareRootsInfoForm.vue?vue&type=style&index=0&id=34cf1c57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cf1c57",
  null
  
)

export default component.exports